export default "__VITE_ASSET__bbb9630b__"